<button
  type="button"
  class="tw-flex tw-h-[42px] tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-bg-gray-50 tw-px-3"
  [ngClass]="[isOpen() || isActive() ? 'tw-border-blue-600' : 'tw-border-gray-300', maxWidthClass()]"
  [attr.aria-label]="ariaLabel()"
>
  <span class="tw-flex tw-min-w-0 tw-items-center tw-gap-1.5">
    @if (shortLabel(); as short) {
      <span class="tw-hidden lg:tw-flex xl:tw-hidden tw-min-w-0">
        <app-truncation-tooltip [text]="short" [tooltipText]="label()" [hostNgClass]="labelClasses()" />
      </span>
      <span class="tw-flex lg:tw-hidden xl:tw-flex tw-min-w-0">
        <app-truncation-tooltip [text]="label()" [hostNgClass]="labelClasses()" />
      </span>
    } @else {
      <app-truncation-tooltip [text]="label()" [hostNgClass]="labelClasses()" />
    }
    @if (showCount()) {
      <span class="tw-flex tw-size-5 tw-shrink-0 tw-items-center tw-justify-center tw-rounded tw-bg-blue-100 tw-font-inter tw-text-xs tw-font-medium tw-leading-normal tw-text-blue-800">
        {{ selectedCount() }}
      </span>
    }
  </span>
  <svg class="tw-shrink-0" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.01475 9.50098C5.69651 9.50091 5.39134 9.3782 5.16635 9.15984L0.366346 4.50271C0.251734 4.39531 0.160315 4.26684 0.0974242 4.12479C0.0345334 3.98275 0.00142989 3.82997 4.53085e-05 3.67538C-0.00133927 3.52078 0.0290225 3.36747 0.0893596 3.22439C0.149697 3.0813 0.2388 2.95131 0.351472 2.84199C0.464143 2.73267 0.598125 2.64622 0.745601 2.58768C0.893077 2.52914 1.05109 2.49968 1.21043 2.50102C1.36976 2.50236 1.52723 2.53448 1.67363 2.5955C1.82004 2.65652 1.95245 2.74522 2.06315 2.85642L6.01475 6.6904L9.96635 2.85642C10.1927 2.64434 10.4958 2.52698 10.8104 2.52964C11.1251 2.53229 11.426 2.65473 11.6485 2.8706C11.871 3.08647 11.9972 3.37849 12 3.68376C12.0027 3.98903 11.8817 4.28313 11.6631 4.50271L6.86315 9.15984C6.63815 9.3782 6.33298 9.50091 6.01475 9.50098V9.50098Z" fill="#374151"/>
  </svg>
</button>
